import { 
    UnstyledButton,
    Group,
    ThemeIcon,
    Anchor,
    Center
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import classes from './MainLink.module.css';

interface MainLinkProps {
    href: string;
    icon: React.ReactNode;
    color: string;
    label: string;
    open: boolean;
}

export const MainLink = ({ href, icon, color, label, open }: MainLinkProps) => {
    const { t } = useTranslation();
    return (
        <Link to={href} style={{ textDecoration: 'none' }} >
            <UnstyledButton className={classes.button}>
                <Group style={ open ? {} : { gap: 0 } } p={8}>
                    <Center>
                        <ThemeIcon 
                            c={color} 
                            variant="light">
                            {icon}
                        </ThemeIcon>
                    </Center>
                    <Anchor hiddenFrom='md' size="sm">
                        {t(label)}
                    </Anchor>
                    <Anchor visibleFrom='md' size="sm">
                        { open && t(label) }
                    </Anchor>
                </Group>
            </UnstyledButton>
        </Link>
    );
}